import call from "../../../shared/service/http";
import FocusAreasContants from "@/packages/focus-areas/FocusAreasContants";

export default {
    namespaced: true,
    state: {
        focusAreas: [],
    },
    mutations: {
        MUTATE: (state, payload) => {
            state[payload.state] = payload.data;
        },
    },
    getters: {
        FocusAreaGetter: (state) => (setup) => state[setup],
    },
    actions: {
        /**
         *
         * @param commit
         */
        focusAreas({commit}) {
            call('get', FocusAreasContants.FOCUS_AREA)
                .then(res=> {
                    if (res.data.success) {
                        commit("MUTATE", {
                            state: "focusAreas",
                            data: res.data.data,
                        });
                    }
                    else{
                        Event.$emit("ApiError", 'Something went wrong');
                    }
                })
                .catch(err=>{
                    Event.$emit("ApiError", err.response.data.message);
                })
        },
        /**
         *
         * @param placeholder
         * @param payload
         */
        focusArea({dispatch}, payload) {
            call('post', FocusAreasContants.FOCUS_AREA, payload)
                .then(res=> {
                    if (res.data.success) {
                        Event.$emit("ApiSuccess", res.data.message)
                        dispatch('focusAreas')
                    }
                    else{
                        Event.$emit("ApiError", 'Something went wrong');
                    }
                })
                .catch(err=>{
                    Event.$emit("ApiError", err.response.data.message);
                })
        }
    }
}
